<template>
    <div class="app-inner">
            <div class="public-btn-div public-btn-small flex align-cen" style="padding-left:0">
                <div class="public-add" @click="addBanner">
                    新增轮播图
                </div>
                <div class="public-btn-small-plan" @click="bannerSort">
                    轮播图排序
                </div>
                </div>
         <div class="p-tit-c">
             <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
                    <div class="label">轮播图名称：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入轮播图名称" v-model="search" clearable> </el-input>
                    </div>
                    </div>
                     <div class="fl-rt flex align-cen">
                    <div class="label">轮播图ID：</div>
                    <div class="el-select1">
                        <el-input placeholder="请输入轮播图ID" v-model="search1" clearable> </el-input>
                    </div>
                    </div>
                </div>
                  <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
                  <div class="label">发布渠道：</div>
                <el-select v-model="value" placeholder="请选择【一级】"
                @change="classSelect"
                clearable
                >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                      >
                    </el-option>
                  </el-select>
                </div>
                 <div class="fl-rt flex align-cen">
                  <el-select v-model="value2" placeholder="请选择【二级】"
                @change="classSelect1"
                clearable
                >
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                      >
                    </el-option>
                  </el-select>
                 </div>
      </div>
             <div class="businessList-filter-list flex align-cen">
                    <div class="label">启用状态：</div>
                      <div
                            style="color: red; padding-right: 20px; cursor: pointer"
                            @click="allradio"
                            >
                            不限
                            </div>
                        <el-radio v-model="radio" label="1" @change="classSelect">启用</el-radio>
                        <el-radio v-model="radio" label="0" @change="classSelect">禁用</el-radio>
                 </div>
          <div class="businessList-filter-list flex align-cen">
                     <div class="label">创建时间：</div>
                      <el-date-picker
                            v-model="value1"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect"
                            >
                            </el-date-picker>
                  </div>
                             <div class="businessList-filter-list flex align-cen public-btn-small">
                            <div class="public-btn-small-primary" @click="classSelect">
                            搜索
                            </div>
                            <div class="public-btn-small-text" @click="reset">
                            重置筛选条件
                            </div>
      </div>
             </div>
         </div>
            <div class="businessList-container">
            <div class="businessList-container-table">
                 <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
         <el-table-column  label="缩略图" align="center" width="150">
            <template slot-scope="scope">
              <!-- <div>
                {{}}
              </div> -->

                <img :src="scope.row.picUrl" alt="" style="height:48px;width:129px" v-if="getResourceType(scope.row.picUrl) == 'img'">
                <VideoPlay
                 v-show="true"
                :videoUrl="scope.row.picUrl"
                :height="48"
                :width="129"
                :autoplay="false"
                :controls="false"
                :loop="false"
                :muted="false"
                preload="auto"
                :showPlay="false"
                :playWidth="96"
                zoom="cover"
                v-if="getResourceType(scope.row.picUrl) == 'video'"
              />

            </template>
          </el-table-column>
          <el-table-column prop="id" label="轮播图ID" align="center">
          </el-table-column>
           <el-table-column  label="发布渠道" align="center">
            <template slot-scope="scope">
              <div>
                {{scope.row.channelFirst}}-{{scope.row.channelSecond}}
              </div>
            </template>
          </el-table-column>
           <el-table-column prop="createTime" label="创建时间" align="center">
          </el-table-column>
           <el-table-column  label="创建人" align="center">
            <template slot-scope="scope">
               <div>{{scope.row.createBy}}</div>
                <!-- <div>{{scope.row.name}}</div> -->
            </template>
          </el-table-column>
             <el-table-column  label="启用状态" align="center">
            <template slot-scope="scope">
                <div class="buStatus" @click.stop="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
           <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="150"          
            >
            <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" @click.stop="addBanner(scope.row)">编辑</el-button>
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="deletBanner(scope.row)">删除</el-button>
            </template>
            </el-table-column>
     </el-table>
      <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
            </div>
            </div>
              <canvas
      id="mycanvas"
      style="display: none"
    ></canvas>
    </div>
</template>
<script>
import { websiteBanner, bannerState, deleteBanner} from "@/api/index/index"  //轮播图列表、轮播图状态改变、轮播图删除
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import VideoPlay from '@/components/VideoPlay'
export default {
    name:'Banner',
    components:{
      paginaTion,
       VideoPlay
    },
    data() {
        return {
            urlType:'img',
            list:[],
            search:'',
            search1:'',
            value:'',
            radio:'',
            value1:'',
            value2:'',
            start_time:'',
            end_time:'',
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
       options:[
              {
               value: '1',
               label: '和隆优化官网'
              },
              {
               value: '2',
               label: '和隆软件官网'
              },
               {
               value: '3',
               label: '微信小程序'
              }
              ],
              options1:[
              ],
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
             },
        }
    },
        activated(){
  this.gethisInfo()
},
    created() {
        
    },
    methods: {
      videoCover(url){
        console.log(url)
         const video = this.$refs.video; // 获取视频对象
         
      // const video = document.createElement("video") // 也可以自己创建video
      video.src = url; // url地址 url跟 视频流是一样的
      var canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
      const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1; // 第一帧
      video.oncanplay = () => {
        canvas.width = video.clientWidth; // 获取视频宽度
        canvas.height = video.clientHeight; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
        // 转换成base64形式
        return canvas.toDataURL("image/png"); // 截取后的视频封面
      };
      },
       getResourceType(url) {
         const extension = url.split('.').pop().toLowerCase(); 
         if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') 
         { return 'img'; }
          else if (extension === 'mp4' || extension === 'avi' || extension === 'mov' || extension === 'wmv') 
         { return 'video'; } 
         else { return 'unknown'; } 
         },
      // 自组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
        // 轮播图状态改变
            changeStatus(e){
        let params = {
            id:e.row.id,
            state:e.row.state == 1 ? '0' : '1'
        }
                  bannerState(params)
                        .then(res => {
                           if(res.code == 0){
                            e.row.state == 1 ? this.$util.Notifi('已禁用','error','fa-exclamation-circle') : this.$util.Notifi('启用成功','success','fa-check')
                           }else{
                            this.$message.error(res.msg)
                            
                           }
                           this.gethisInfo()
                        })
                        .catch(err => {
                        })
      },
        // 轮播列表
        gethisInfo(){
          let params = {
            name:this.search,
            id:this.search1,
            channelFirst:this.value,
            channelSecond:this.value2,
            state:this.radio,
            createTimeStart:this.start_time,
            createTimeEnd:this.end_time,
            size:this.PageSize,
            current:this.currentPage,
            orderBy:''
          }
          websiteBanner(params)
          .then(res => {
            this.list = res.data.records
            this.totalCount = res.data.total
          })
          .catch(err => {

          })
        },
        allradio(){
          this.radio = ""
          this.currentPage = 1
           this.gethisInfo()
        },
        // 重置
        reset(){
          this.search = ""
          this.search1 = ""
          this.radio = ""
          this.value = ""
          this.value1 = ""
          this.value2 = ""
          this.start_time = ""
          this.end_time = ""
          this.currentPage = 1
           this.gethisInfo()
        },
          // 企业分类筛选
        classSelect(){
         if(this.value == '和隆优化官网' || this.value == '和隆软件官网'){
        this.options1 = [
               {
               value: '1',
               label: '官网首页'
              },
              {
               value: '2',
               label: '课程首页-网页端'
              }
        ]
        this.value2 = ''
       }else if(this.value == '微信小程序'){
        this.options1 = [ 
          {
             value: '1',
               label: '获客小程序首页'
          }
        ]
             this.value2 = ''
       }else{
        this.value2 = ''
        this.options1 = []
       }
            if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }
            else{
                this.start_time=""
                this.end_time = ""
            }
            this.currentPage = 1
            this.gethisInfo()
        },
        classSelect1(){
            if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }
            else{
                this.start_time=""
                this.end_time = ""
            }
            this.currentPage = 1
            this.gethisInfo()
        },
        // 轮播图删除
        deletBanner(data){
          if(data.state == '1') return this.$util.Notifi('您需要先禁用该轮播图后方能删除，请先禁用轮播图','error','fa-exclamation-circle')
         this.$confirm('轮播图删除后将无法展示, 确认删除吗?', '删除轮播图', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deleteBanner({
              id:data.id,
              },'delete')
                .then(res => {
                 this.$util.Notifi('删除成功','success','fa-check')
                   this.gethisInfo()
              })
              .catch(err => {
              })
        })
        },
        // 新增轮播图
        addBanner(data){
            data.id ? this.$router.push({name:'addBanner',query:{id:data.id}}) : this.$router.push("/addBanner")
        },
        // 打开轮播图排序
        bannerSort(){
             this.$router.push("/bannerSort")
        },
    },
}
</script>
<style lang="scss" scoped>
  .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
  ::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
}
</style>